// extracted by mini-css-extract-plugin
export default {"container":"CheckboxSelect_container__vC7so","labels":"CheckboxSelect_labels__EnLqv"};